import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Chip from '@material-ui/core/Chip';
import Grid from '@material-ui/core/Grid';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';

import DatePicker from '../../date-picker';

import { styles } from './styles';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function GridFilterDropdown({
  options,
  onChange,
  iconType = 'search',
}) {
  const classes = styles();
  const [inputValue, setInputValue] = useState('');
  const handleInputChange = (e, val) => {
    e.preventDefault();
    e.stopPropagation();
    setInputValue(val);
    onChange(val ? val : '');
  };

  return iconType === 'search' ? (
    <Autocomplete
      multiple
      disableCloseOnSelect
      className={classes.root}
      getOptionLabel={(option) => option.name}
      onChange={handleInputChange}
      renderOption={(option, { selected }) => (
        <Grid
          container
          direction="row"
          alignItems="center"
          className={classes.paperDesign}
        >
          <Grid item>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={
                selected
                  ? { marginRight: 8, color: 'rgb(2, 123, 253)' }
                  : { marginRight: 8 }
              }
              checked={selected}
            />
          </Grid>
          <Grid item>{option.name}</Grid>
        </Grid>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          className={classes.inputControl}
          value={inputValue}
          variant="outlined"
          placeholder="Search"
          fullWidth={true}
          size="small"
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <>
                <InputAdornment position="start">
                  <SearchIcon style={{ color: '#999' }} />
                </InputAdornment>
                {params.InputProps.startAdornment}
              </>
            ),
          }}
        />
      )}
      renderTags={(value, getTagProps) => (
        <Chip
          variant="outlined"
          label={
            value.length === 1 ? value[0].name : `${value.length} selected`
          }
          size="small"
          className={classes.selectedOptionsChip}
          title={
            value.length === 1
              ? value[0].name
              : `${value.length} options selected. Expand the dropdown to view the selections`
          }
        />
      )}
      noOptionsText={
        <div style={{ border: '1px solid #dddddd', margin: '-14px' }}>
          No Options
        </div>
      }
      options={options}
      fullWidth={true}
      ListboxProps={{
        style: {
          maxHeight: '350px',
          border: '1px solid #dddddd',
        },
      }}
    />
  ) : (
    <div className={classes.dateControl}>
      <DatePicker handle={onChange} />
    </div>
  );
}
